/** DataGrid `sx` for ScorecardChart — extracted to keep the component under
 *  the file-size limit. `primaryColor` is the resolved Primary Brand
 *  highlight color (the researcher's custom color, or the default theme
 *  blue) — applied to whichever column currently holds the Primary role,
 *  wherever it sits in the display order. */
export function getScorecardGridSx(primaryColor: string) {
  return {
    height: "100%",
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeader": {
      borderRight: "1px solid #E0E0E0",
      "& .MuiDataGrid-columnHeaderTitle": {
        fontWeight: 700,
      },
    },
    "& .MuiDataGrid-cell": {
      borderRight: "1px solid #E0E0E0",
    },
    "& .MuiDataGrid-columnHeader.scorecard-last-column": {
      borderRight: "none",
    },
    "& .MuiDataGrid-cell.scorecard-last-column": {
      borderRight: "none",
    },
    "& .scorecard-heading-row": {
      backgroundColor: "#F5F5F5",
      "&:hover": {
        backgroundColor: "#F5F5F5",
      },
    },
    "& .scorecard-heading-cell": {
      fontWeight: 700,
    },
    "& .scorecard-primary-column": {
      borderLeft: `2px solid ${primaryColor}`,
      borderRight: `2px solid ${primaryColor}`,
    },
    "& .scorecard-primary-column-top": {
      borderTop: `2px solid ${primaryColor}`,
    },
    "& .scorecard-primary-column-bottom": {
      // The MUI DataGrid empty-state adds its own
      // `.MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader` rule
      // (two-class specificity), which otherwise beats this override
      // when there are no rows yet.
      borderBottom: `2px solid ${primaryColor} !important`,
    },
    "& .scorecard-primary-header-text": {
      color: primaryColor,
    },
  };
}
